import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import theme from './theme';
import { canSeedLocation } from './environment';

// Small reusable link to drop into per-location tabs (Inventory, Health,
// Schedule, etc.). Only renders when `enabled` (LD flag) is true.

const Wrapper = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: ${theme.radius.md};
  border: 1px solid ${theme.color.accent};
  background: ${theme.color.accentDim};
  color: ${theme.color.accent};
  font-family: ${theme.font.mono};
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-decoration: none;
  transition: all ${theme.motion.quick};
  &:hover,
  &:focus {
    background: ${theme.color.accent};
    color: #052e1a;
    text-decoration: none;
    outline: none;
  }
`;

export default function SeedInventoryButton({ locationId, enabled, compact }) {
  if (!enabled || !locationId) return null;
  if (!canSeedLocation(locationId)) return null;
  return (
    <Wrapper to={`/locations/inventory-stocking/${locationId}`}>
      {compact ? 'Seed' : 'Seed this fridge'}
    </Wrapper>
  );
}
